module.exports = __webpack_public_path__ + "static/media/bg-btn-prize.5dc420ee.svg";